import "./menu.scss"

export default function menu({menuOpen, setMenuOpen}) {
    return (
        <div className={"menu " + (menuOpen && "active")} >
            <ul>
                <li onClick={() => setMenuOpen(false)}>
                    <a href="#about">About</a>
                </li>
                
                <li onClick={() => setMenuOpen(false)}>
                    <a href="#works">Works</a>
                </li>
                <li onClick={() => setMenuOpen(false)}>
                    <a href="#about">Resume</a>
                </li>
                <li onClick={() => setMenuOpen(false)}>
                    <a href="#footer">Socials</a>
                </li>
            </ul>
        </div>
    )
}
